import { useState, useEffect } from "react";
import { apiRequest } from "@/api/base";

export const useInvitation = () => {
  const [invitationId, setInvitationId] = useState<string | null>(null);
  const [invitation, setInvitation] = useState<any>(null);
  const [showInvitationBanner, setShowInvitationBanner] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const invitationParam = urlParams.get('invitation');
    if (invitationParam) {
      setInvitationId(invitationParam);
      
      const fetchInvitation = async () => {
        try {
          const invitationData = await apiRequest<any>(
            `/api/invitations/preview/${invitationParam}`,
            "GET",
            undefined,
            false
          );
          setInvitation(invitationData);
          setShowInvitationBanner(true);
        } catch (err) {
          console.error("Failed to fetch invitation:", err);
        }
      };
      
      fetchInvitation();
    }
  }, []);

  return {
    invitationId,
    invitation,
    showInvitationBanner,
    setShowInvitationBanner,
  };
};